<template>
  <b-overlay
    :show="loader.form"
    rounded="sm"
    no-center
    bg-color="white"
  >
    <template
      #overlay
    >
      <div
        class="text-center"
        style="margin-top:15%"
      >
        <feather-icon
          icon="ClockIcon"
          size="32"
        />
        <p id="cancel-label">
          Por favor espere...</p>
      </div>
    </template>
    <div>
      <InstruccionesAsesor v-if="userRol.id==4" />
      <InstruccionesControl v-if="userRol.id==2" />

      <!--  el 4  es el asesor/2 control escolar-->
      <!-- Filters -->
      <users-list-filters
        :plan-filter.sync="planFilter"
        :cursos-filter.sync="cursosFilter"
        :periodo-filter.sync="periodoFilter"
        :planes="planes"
        :cursos="cursos"
        :status-options="statusOptions"
        :periodos="periodos"
        :deshabilitar-cursos="deshabilitarCursos"
      />
      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Mostrar</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>páginas</label>
            </b-col>

            <!-- Search -->
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Buscar por alumno..."
                />
                <template>
                  <div class="float-right ">
                    <b-dropdown
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      text="Calificaciones"
                      variant="outline-primary"
                      :disabled="deshabilitarCursos"
                    >
                      <b-dropdown-item
                        v-if="(userRol.id == 4 || userRol.id == 3) && usersAux !== undefined"
                        @click="aprobarCalificacion"
                      >
                        Terminar y validar
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="userRol.id == 2 || userRol.id == 3"
                        @click="sendCalifMoodle()"
                      >
                        Pre-cierre
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="userRol.id == 2|| userRol.id == 3"
                        @click="autorizarCalif()"
                      >
                        Autorizar
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="userRol.id == 2 || userRol.id == 3"
                        @click="cerrarCiclo()"
                      >
                        Cerrar ciclo
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <b-modal
                    id="modal-sm"
                    ref="my-modal"
                    ok-title="Aceptar"
                    cancel-title="Cancelar"
                    cancel-variant="outline-secondary"
                    centered
                    size="sm"
                    title="Confirmación de calificaciones"
                    @ok="registroExitoso()"
                  >
                    <b-card-text>Valido que he revisado la información capturada y estoy de acuerdo con lo ingresado?</b-card-text>
                  </b-modal>
                  <!-- modal solicitud de ajuste-->
                  <b-modal
                    id="modal-solicitud"
                    ref="solicitud-cambio"
                    cancel-variant="outline-secondary"
                    ok-title="Enviar"
                    cancel-title="Close"
                    centered
                    title="Solicitud de ajuste de calificación"
                    @ok="handleEnviar()"
                  >
                    <b-form>
                      <b-form-group>
                        <label for="solicitud">Razón de la solicitud:</label>
                        <validation-provider
                          #default="{ errors }"
                          rules="required"
                          name="solicitud"
                        >
                          <!-- v-model="" falta -->
                          <b-form-textarea
                            v-model="textareaSolicitud"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Escribe aquí la razón para crear la solicitud de ajuste de calificación"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-form>
                  </b-modal>
                </template>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          v-show="usersAux !== null || usersAux !== undefined"
          ref="refUserListTable"
          class="position-relative"
          :items="fetchUsers"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No se encontraron resultados para esta búsqueda"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <!-- Column: User -->
          <template #cell(nombre_completo)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="32"
                  :src="data.item.avatar"
                />
              </template>
              <span>
                {{ data.item.nombre_completo }}
              </span>
            </b-media>
          </template>
          <template
            #cell(calif)="data"
          >
            <b-media
              vertical-align="center"
            >
              <b-row
                v-if="data.item.calif[0]"
              >
                <b-col>
                  <div>
                    <b-form-group
                      :label="'1) Calificación Moodle'"
                      label-for="floating-label1"
                    >
                      <b-form-input
                        id="floating-label1"
                        v-model="data.item.calif[0].calif_moodle"
                        disabled
                      />
                    </b-form-group>
                  </div>
                  <div v-if="userRol.id==2">
                    <b-form-group
                      :label="'3) Calificación autorizada'"
                      label-for="floating-califaut"
                    >
                      <b-form-input
                        id="floating-califaut"
                        v-model="data.item.calif[0].calif"
                        disabled
                      />
                      <small>Esta calificación será la guardada en el Kardex</small>
                    </b-form-group>
                  </div>
                  <div v-if="userRol.id==2">
                    <b-form-group
                      :label="'4) Calificación en Kardex'"
                      label-for="floating-califk"
                    >
                      <small>Status del Kardex: {{ data.item.k_status }}</small>
                      <b-form-input
                        id="floating-califk"
                        v-model="data.item.cal_fin"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </b-col>
                <b-col
                  lg="6"
                  class="mb-1"
                >
                  <b-form-group
                    :label="(userRol.id==2)?'2) Calificación del Profesor':'Nueva Calificación'"
                    label-for="floating-labelp"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="nueva calificación"
                      rules="between:0,100"
                    >
                      <b-form-input
                        id="floating-label1"
                        v-model="data.item.calif[0].calif_profesor"
                        :disabled="(data.item.calif.length> 0)?data.item.calif[0].calif_status_id !== 2:userRol.id == 2"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    class="mb-0"
                    label="Observación del profesor"
                    label-for="textarea-lazy"
                    description="Escribe la razón del cambio de la calificación"
                  >
                    <validation-provider
                      #default="{ errors }"
                      rules="required"
                      name="observaciones"
                    >
                      <b-form-textarea
                        id="textarea-formatter"
                        v-model="data.item.calif[0].observacion_profesor"
                        :state="errors.length > 0 ? false:null"
                        :disabled="(data.item.calif.length> 0)?data.item.calif[0].calif_status_id !== 2:userRol.id == 2"
                        placeholder=""
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row
                v-else
              >
                <span>Sin calificar</span>
              </b-row>
            </b-media>
          </template>

          <!-- Column: Opciones -->
          <template
            v-if="userRol.id == 4"
            #cell(solicitud)="data"
          >
            <div
              v-if="
                userRol.id != 2 &&
                  data.item.calif &&
                  data.item.calif.length > 0 &&
                  data.item.calif[0].calif_status_id === 4
              "
            >
              <!-- Edit icon -->
              <b-button
                :id="`${data.item.id}`"
                icon="EditIcon"
                variant="outline-secondary"
                size="small"
                @click="showModalSolicitud(data.item)"
              >
                Solicite Ajuste de calificación
              </b-button>

            </div>
            <div
              v-if="
                userRol.id != 2 &&
                  data.item.calif &&
                  data.item.calif.length > 0 &&
                  data.item.calif[0].calif_status_id === 5
              "
            > Calificación con solicitud de ajuste CHyJ
            </div>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalUsers"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import { getData, postData } from '@core/utils/http/general'
import {
  BCard, BRow, BCol, BFormInput, BTable, BMedia, BAvatar, BFormGroup, VBTooltip, BFormTextarea,
  BDropdown, BDropdownItem, BPagination, BButton, BModal, VBModal, BOverlay, BForm, BCardText,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {
  onMounted, onUnmounted, ref, watch, computed, getCurrentInstance,
} from '@vue/composition-api'
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { avatarText, timestampToDate } from '@core/utils/filter'
import userStoreModule from '@/store/maestro/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { rolesActions } from '@core/mixins/account-data/roles'
import { periodsFromPlan } from '@/views/public/oferta-academica/useDetalleOferta'
import UsersListFilters from './users-list/UsersListFilters.vue'
import useUsersList from './users-list/useUsersList'
import InstruccionesAsesor from './instruccionesCalificaciones/asesor.vue'
import InstruccionesControl from './instruccionesCalificaciones/controlEscolar.vue'

export default {
  components: {
    UsersListFilters,
    BCard,
    BOverlay,
    BCardText,
    BFormTextarea,
    BRow,
    BCol,
    BForm,
    BButton,
    BModal,
    BFormInput,
    BFormGroup,
    BTable,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    ValidationProvider,
    InstruccionesAsesor,
    InstruccionesControl,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mixins: [rolesActions],
  data() {
    return {
      fields: [
        'nombre_completo',
      ],
    }
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'alumnos_calificaciones'

    const toast = useToast()

    const vm = getCurrentInstance().proxy
    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]
    const calendarioselected = ref({ id_plan: null, id_periodo: null })
    const loader = ref({ form: false })
    const isAddNewUserSidebarActive = ref(false)
    const planes = ref([])
    const cursos = ref([])
    const periodos = ref([])
    const cursosTemp = ref([])
    const bndPeriod = ref(false)
    const parciales = ref([{ id: 0, num: 0 }])
    const deshabilitarCursos = ref(false)
    const {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      usersAux,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      planFilter,
      cursosFilter,
      periodoFilter,
    } = useUsersList()

    const userRole = computed(() => store.state.cuenta.rolSelected)
    const idCalifSelected = ref(null)
    const textareaSolicitud = ref(null)

    function loadPeriodos() {
      periodos.value = []
      if (calendarioselected.value.id_plan == null) calendarioselected.value.id_periodo = null
      periodoFilter.value = null // para que no se quede el periodo(int) entre especialidades
      periodsFromPlan(calendarioselected.value.id_plan).then(response => {
        periodos.value = response
        loader.value.form = false
        calendarioselected.value.id_periodo = response[response.length - 1].periodo
      }, error => {
        if (error) this.loader.planEstudios = false
      })
    }

    function obtenerAccesoCalif() {
      loader.value.form = true
      let diaActual = new Date()
      diaActual = diaActual.getTime() / 1000
      if (userRole.value.id !== 3) {
        getData({
          action: 12,
          token: store.state.cuenta.session.token,
          id_rol: userRole.value.id,
          evento: 10,
          periodo: periodoFilter.value,
        }, 'calificaciones')
          .then(response => {
            if (response.status === 200 && response.data.status === 200) {
              deshabilitarCursos.value = false
              if (response.data.data.length > 0) {
                if (diaActual > response.data.data[0].fechaIni && diaActual < response.data.data[0].fechaFin) { // si entra el dia dentro de las fechas
                // entonces muestra el modal
                  const matches = cursosTemp.value.filter(x => x.periodo_id === periodoFilter.value).map(x => x)
                  if (matches.length > 0) {
                    cursos.value = matches
                  } else {
                    cursos.value = []
                  }
                } else {
                  deshabilitarCursos.value = true
                  cursos.value = []
                  cursosFilter.value = null
                  usersAux.value = null
                  toast({
                    component: ToastificationContent,
                    props: {
                      title: `Las fechas para captura de calificaciones son de ${timestampToDate(response.data.data[0].fechaIni)} al ${timestampToDate(response.data.data[0].fechaFin)}`,
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                      solid: true,
                    },
                  })
                }
              } else {
                deshabilitarCursos.value = true
                cursos.value = []
                cursosFilter.value = null
                usersAux.value = null
                toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Parece que no tienes el evento de Evaluación activado o no estas dentro del grupo para poder usarlo. Contacta a control escolar',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                    solid: true,
                  },
                })
              }
            } else {
              deshabilitarCursos.value = true
              toast({
                component: ToastificationContent,
                props: {
                  title: `${response.data.status} - No existe información para esta consulta aún`,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                  solid: true,
                },
              })
            }
          })
          .catch(err => {
            loader.value.form = false
            toast({
              component: ToastificationContent,
              props: {
                title: `${err} - Error en solicitud [profesores]`,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                solid: true,
              },
            })
          })
      } else {
        const matches = cursosTemp.value.filter(x => x.periodo_id === periodoFilter.value).map(x => x)
        if (matches.length > 0) {
          cursos.value = matches
        } else {
          cursos.value = []
        }
        cursosFilter.value = null
      }
      loader.value.form = false
    }

    watch([planFilter], () => {
      calendarioselected.value.id_plan = planFilter.value
      loader.value.form = true
      loadPeriodos()
    })

    watch(periodoFilter, () => { // como vuelve a hacer seecionar el periodo aunque ya haya seleccionado curso
      usersAux.value = null
      cursos.value = [] // y borra los cursos disponibles a elegir
      cursosFilter.value = null // borra el selector de curso
      if (periodoFilter.value !== null) {
        obtenerAccesoCalif()
      }
    })
    watch(cursosFilter, () => {
      usersAux.value = null
      loader.value.form = true
    })

    watch(usersAux, val => {
      if (userRole.value.id === 2) {
        if (tableColumns.length === 6) {
          tableColumns.pop()
        }
      }
      if (val !== null) {
        loader.value.form = false
      }
    })

    function aprobarCalificacion() {
      this.$refs['my-modal'].show()
    }
    function showModalSolicitud(element) {
      textareaSolicitud.value = ''
      let diaActual = new Date()
      diaActual = diaActual.getTime() / 1000
      idCalifSelected.value = element
      // primero checa si puede hacer esto
      // para eso pido los datos de solicitud de ajustes, reviso que este en fecha
      loader.value.form = true
      getData({
        action: 12,
        token: store.state.cuenta.session.token,
        id_rol: userRole.value.id,
        evento: 11,
        periodo: periodoFilter.value,
      }, 'calificaciones')
        .then(response => {
          if (response.status === 200 && (response.data.status === 204 || response.data.status === 200)) {
            if (response.data.data.length > 0) {
              if (diaActual > response.data.data[0].fechaIni && diaActual < response.data.data[0].fechaFin) {
              // entonces muestra el modal
                this.$refs['solicitud-cambio'].show()
              } else {
                toast({
                  component: ToastificationContent,
                  props: {
                    title: `Las fechas para solicitar cambios son de ${timestampToDate(response.data.data[0].fechaIni)} al ${timestampToDate(response.data.data[0].fechaFin)}`,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                    solid: true,
                  },
                })
              }
            } else {
              toast({
                component: ToastificationContent,
                props: {
                  title: 'Por el momento no tenemos fechas para realizar esta solicitud',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                  solid: true,
                },
              })
            }
          } else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Error cargando la información`,
              variant: 'danger',
              solid: true,
            })
          }
          loader.value.form = false
        })
        .catch(err => {
          loader.value.form = false
          toast({
            component: ToastificationContent,
            props: {
              title: `${err} - Error en la solicitud [cambios de calificación]`,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              solid: true,
            },
          })
        })
    }
    function handleEnviar() {
      const object = {
        periodo: idCalifSelected.value.periodo,
        calif_id: idCalifSelected.value.calif[0].id,
        solicita: 'PROF',
        argumento: textareaSolicitud.value,
      }
      // hacer la peticion
      const params = new FormData()
      params.append('task', 'wscomitehonor')
      params.append('origin', process.env.VUE_APP_ORIGIN_API)
      params.append('action', 1)
      params.append('token', store.state.cuenta.session.token)
      params.append('data', JSON.stringify(object))

      postData(params)
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            idCalifSelected.value.calif[0].calif_status_id = 5
            textareaSolicitud.value = ''
            idCalifSelected.value = null
            toast({
              component: ToastificationContent,
              props: {
                title: `${response.data.status} - Solicitud enviada con éxito`,
                icon: 'success',
                variant: 'success',
                solid: true,
              },
            })
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: `${response.data.status} - ${response.data.message}`,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                solid: true,
              },
            })
          }
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: {
              title: `${err} - Error en la solicitud`,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              solid: true,
            },
          })
        })
    }

    function cerrarCiclo() {
      vm.$swal({
        title: '¿ Estás seguro de CERRAR EL CICLO ?',
        html: 'El ciclo se debe de cerrar una vez se haya autorizado las calificaciones de los profesores, asegurate que todos los cursos tengan la calificación autorizada. Al realizar el cierre, la calificación se guardará en kardex de manera definitiva. Si hay alumnos con solicitud de cambio de calificación hay que esperar a cerrar el ciclo hasta que se resuelvan dichas solicitudes.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Proceder',
        cancelButtonText: 'Cancelar!',
        allowOutsideClick: false,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          loader.value.form = true
          const tc = cursosFilter.value
          if (planFilter.value !== null && periodoFilter.value !== null) {
            const params = new FormData()
            params.append('task', 'wsparticipantes')
            params.append('origin', process.env.VUE_APP_ORIGIN_API)
            params.append('action', 15)
            params.append('token', store.state.cuenta.session.token)
            params.append('plan', planFilter.value)
            params.append('periodo', periodoFilter.value)

            postData(params)
              .then(response => {
                if (response.status === 200 && response.data.status === 200) {
                  cursosFilter.value = null
                  this.$swal({
                    title: 'Todos los cursos para este plan han sido cerrados con éxito',
                    html: '',
                    icon: 'success',
                    timer: 10000,
                    showConfirmButton: false,
                    buttonsStyling: false,
                  })
                } else {
                  toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Por el momento no se puede cerrar ciclo puede ser que un asesor no haya validado alguna calificación',
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                      solid: true,
                    },
                  })
                }
                loader.value.form = false
              })
              .finally(() => {
                cursosFilter.value = tc
              })
              .catch(err => {
                loader.value.form = false
                toast({
                  component: ToastificationContent,
                  props: {
                    title: `${err} - Error en la solicitud de validación`,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                    solid: true,
                  },
                })
              })
            loader.value.form = false
          } else {
            loader.value.form = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Por favor selecciona un plan de Estudios y un periodo válido',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                solid: true,
              },
            })
          }
        }
      })
    }

    function autorizarCalif() {
      vm.$swal({
        title: '¿ Estás seguro de AUTORIZAR calificaciónes ?',
        html: 'La autorización se realiza una vez que todos los responsables de materias hayan validado las calificaciónes extraidas de moodle, revisa que todos los cursos tengan la calificación del profesor.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Proceder',
        cancelButtonText: 'Cancelar!',
        allowOutsideClick: false,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          loader.value.form = true
          const tc = cursosFilter.value
          if (planFilter.value !== null && periodoFilter.value) {
            const params = new FormData()
            params.append('task', 'calificaciones')
            params.append('origin', process.env.VUE_APP_ORIGIN_API)
            params.append('action', 14)
            params.append('token', store.state.cuenta.session.token)
            params.append('id_plan', planFilter.value)
            params.append('periodo', periodoFilter.value)

            postData(params)
              .then(response => {
                if (response.status === 200 && response.data.status === 200) {
                  cursosFilter.value = null
                  this.$swal({
                    title: '<b>Calificaciones autorizadas exitosamente para este plan de Estudios.</b>',
                    html: '',
                    icon: 'success',
                    timer: 10000,
                    showConfirmButton: false,
                    buttonsStyling: false,
                  })
                  loader.value.form = false
                } else {
                  toast({
                    component: ToastificationContent,
                    props: {
                      title: `${response.data.status} - ${response.data.message}`,
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                      solid: true,
                    },
                  })
                  loader.value.form = false
                }
              })
              .finally(() => {
                cursosFilter.value = tc
              })
              .catch(err => {
                loader.value.form = false
                toast({
                  component: ToastificationContent,
                  props: {
                    title: `${err} - Error en la solicitud de validación`,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                    solid: true,
                  },
                })
              })
          } else {
            loader.value.form = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Por favor selecciona un plan de Estudios y un Periodo válido',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                solid: true,
              },
            })
          }
        }
      })
    }
    function registroExitoso() {
      loader.value.form = true

      const calificacionesProfesor = usersAux.value
        .filter(item => {
          const calif = item.calif && item.calif[0]

          return (
            calif
            && calif.calif_profesor !== ''
            && calif.observacion_profesor
            && calif.observacion_profesor.trim() !== ''
          )
        })
        .map(item => ({
          calif_id: item.calif[0].id,
          calif_profesor: item.calif[0].calif_profesor,
          observacion_profesor: item.calif[0].observacion_profesor,
        }))
      const modificadas = {}
      const tc = cursosFilter.value
      const params = new FormData()
      modificadas.calificaciones = calificacionesProfesor

      params.append('task', 'calificaciones')
      params.append('origin', process.env.VUE_APP_ORIGIN_API)
      params.append('action', 13)
      params.append('token', store.state.cuenta.session.token)
      params.append('id_plan', planFilter.value)
      params.append('id_curso', cursosFilter.value)
      params.append('periodo', periodoFilter.value)
      params.append('modificaciones', JSON.stringify(modificadas))
      postData(params)
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            cursosFilter.value = null
            this.$swal({
              title: '<b>Calificaciones agregadas con éxito</b>',
              html: '',
              icon: 'success',
              timer: 10000,
              showConfirmButton: false,
              buttonsStyling: false,
            })
            refetchData()
            loader.value.form = false
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: `${response.data.status} - Error - ${response.data.message}`,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                solid: true,
              },
            })
            loader.value.form = false
          }
        })
        .finally(() => {
          cursosFilter.value = tc
        })
        .catch(err => {
          loader.value.form = false
          toast({
            component: ToastificationContent,
            props: {
              title: `${err} - Error en la solicitud para sus calificaciones`,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              solid: true,
            },
          })
        })
    }
    function sendCalifMoodle() {
      vm.$swal({
        title: '¿Estás seguro de realizar este paso?',
        html: 'El pre cierre es para extraer las calificaciónes de moodle y guardarlos en la boleta de calificaciónes de Campus Virtual.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Proceder',
        cancelButtonText: 'Cancelar!',
        allowOutsideClick: false,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          loader.value.form = true
          const tc = cursosFilter.value
          if (planFilter.value !== null && periodoFilter.value !== null) {
            const params = new FormData()
            params.append('task', 'calificaciones')
            params.append('origin', process.env.VUE_APP_ORIGIN_API)
            params.append('action', 11)
            params.append('token', store.state.cuenta.session.token)
            params.append('id_plan', planFilter.value)
            params.append('periodo', periodoFilter.value)

            postData(params)
              .then(response => {
                if (response.status === 200 && response.data.status === 200) {
                  cursosFilter.value = null
                  toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Se ha realizado con éxito el pre-cierre',
                      icon: 'BellIcon',
                      variant: 'success',
                      solid: true,
                    },
                  })
                } else {
                  toast({
                    component: ToastificationContent,
                    props: {
                      title: ` ${response.data.message}`,
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                      solid: true,
                    },
                  })
                }
                loader.value.form = false
              })
              .finally(() => {
                cursosFilter.value = tc
              })
              .catch(err => {
                loader.value.form = false
                toast({
                  component: ToastificationContent,
                  props: {
                    title: `${err} - Error en la solicitud de pre-cierre`,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                    solid: true,
                  },
                })
              })
          } else {
            loader.value.form = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Por favor selecciona plan de Estudios y periodo válido',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                solid: true,
              },
            })
          }
        }
      })
    }

    function getFilters() {
      getData({
        action: 8,
        token: store.state.cuenta.session.token,
        idRol: userRole.value.id,
      }, 'wsparticipantes')
        .then(response => {
          if (response.data) {
            if (response.status === 200 && response.data.status === 200) {
              planes.value = response.data.data.planes
              cursosTemp.value = response.data.data.cursos
            } else {
              toast({
                component: ToastificationContent,
                props: {
                  title: `${response.data.status} - Error cargando datos para filtros`,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                  solid: true,
                },
              })
            }
          }
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: {
              title: `${err} - Por el momento no podemos traer los planesde estudio. Intente de nuevo más tarde`,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              solid: true,
            },
          })
        })
    }

    onMounted(() => {
      getFilters()
    })

    return {
      sendCalifMoodle,
      // updateParcial,
      registroExitoso,
      autorizarCalif,
      cerrarCiclo,
      deshabilitarCursos,
      // Sidebar
      isAddNewUserSidebarActive,
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      bndPeriod,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      cursosTemp,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      usersAux,
      loadPeriodos,
      aprobarCalificacion,
      showModalSolicitud,
      userRole,
      idCalifSelected,
      textareaSolicitud,
      getFilters,
      obtenerAccesoCalif,

      // Filter
      avatarText,

      // formulario
      handleEnviar,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      planes,
      calendarioselected,
      periodos,
      cursos,
      parciales,
      // periodoActual,
      statusOptions,

      // Extra Filters
      planFilter,
      cursosFilter,
      periodoFilter,

      // loader
      loader,
      // validacion
      required,
    }
  },
}
</script>

<style>

</style>
